import { Button, ButtonGroup, useMediaQuery } from "@material-ui/core";
import { Check, FileCopy, Phone } from "@material-ui/icons";
import React, { useState } from "react";
import { segmentTrack } from "../../../helpers/segment";

export const campaignPhoneNumbers: any = {
  "alcohol-disposal": "415-417-0239",
  "beverage-disposal": "415-417-0239",
  "hazardous-waste-disposal": "415-417-0239",
  "junk-disposal": "415-417-0239",
  "sanitizer-disposal": "415-417-0239",
  "solar-panel-disposal": "415-417-0239",
  "solar-panel-sell": "415-417-0239",
  "fire-debris-removal": "415-417-0239",
  "certified-destruction": "415-417-0239",
  "e-waste": "415-417-0239",
};

export const defaultCampaignPhoneNumber = "415-417-0239";

export const CallToBook = ({ formId, condensed, header }: any) => {
  const [copied, setCopied] = useState(false);
  const ref = React.createRef<any>();
  const isMobile = useMediaQuery("(max-width:1000px)");

  const formTexts: any = {
    ["sanitizer-disposal"]: {
      text: isMobile ? "Call for instant quote" : "Call us for an immediate quote",
      number: "415-417-0239",
    },
    ["solar-panel-disposal"]: {
      text: isMobile ? "Call for instant quote" : "Call us for an immediate quote",
      number: "415-417-0239",
    },
    ["solar-panel-sell"]: {
      text: isMobile ? "Call for instant quote" : "Call us for an immediate quote",
      number: "415-417-0239",
    },
    ["hazardous-waste-disposal"]: {
      text: isMobile ? "Call for instant quote" : "Call us for an immediate quote",
      number: "415-417-0239",
    },
    ["beverage-disposal"]: {
      text: isMobile ? "Call for instant quote" : "Call us for an immediate quote",
      number: "415-417-0239",
    },
    ["alcohol-disposal"]: {
      text: isMobile ? "Call for instant quote" : "Call us for an immediate quote",
      number: "415-417-0239",
    },
    ["compost-disposal"]: {
      text: isMobile ? "Call for instant quote" : "Call us for an immediate quote",
      number: "415-417-0239",
    },
    ["fire-debris-removal"]: {
      text: isMobile ? "Call for instant quote" : "Call us for an immediate quote",
      number: "415-417-0239",
    },
    ["e-waste"]: {
      text: isMobile ? "Call for instant quote" : "Call us for an immediate quote",
      number: "415-417-0239",
    },
    ["certified-destruction"]: {
      text: isMobile ? "Call for instant quote" : "Call us for an immediate quote",
      number: "415-417-0239",
    },
  };

  const formText = formTexts[formId];

  const handleClick = () => {
    segmentTrack("Disposal Flow - Call to Book", {
      formId,
      phoneNumber: formText?.number,
      from: condensed ? "header" : "form",
    });
    segmentTrack("Disposal Flow - Clicked Phone Number", {
      formId,
      phoneNumber: formText?.number,
      from: condensed ? "header" : "form",
    });
    window.open(`tel:${formText?.number}`);
  };

  const handleCopy = () => {
    const number: any = ref.current?.innerText;
    segmentTrack("Disposal Flow - Call to Book", {
      formId,
      phoneNumber: number,
      from: condensed ? "header" : "form",
    });
    segmentTrack("Disposal Flow - Copied Phone Number", {
      formId,
      phoneNumber: number,
      from: condensed ? "header" : "form",
    });
    navigator.clipboard.writeText(number);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  if (!formText) return <div />;

  const style = condensed
    ? {
        display: "block",
        alignItems: "center",
        width: "max-content",
        background: "none",
      }
    : {
        display: "grid",
        gridTemplateColumns: "auto max-content",
        columnGap: 8,
        padding: "0px 0px 4px",
        // borderBottom: "1px solid #ccc",
        alignItems: "center",
        marginTop: -18,
        marginBottom: 8,
      };

  const condensedFontStyles = {
    fontFamily: "DM Sans",
    letterSpacing: "2px",
    fontSize: "13px",
  };

  return (
    <div style={style}>
      {!condensed && <p style={{ fontFamily: `"Inter", sans-serif`, fontSize: 16, fontWeight: "bold" }}>{formText?.text}</p>}
      <ButtonGroup
        variant="contained"
        size="small"
        style={{ height: 44, borderRadius: 10, boxShadow: "none", background: condensed ? "none" : undefined }}
      >
        <Button
          size={condensed ? "medium" : "small"}
          onClick={handleClick}
          style={{
            height: 44,
            background: condensed ? "none" : "#fafafa",
            borderRight: condensed ? undefined : "1px solid #eee",
            textDecoration: condensed ? undefined : "underline",
            ...(condensed ? condensedFontStyles : {}),
          }}
          startIcon={condensed ? undefined : <Phone />}
          ref={ref}
        >
          {`${header ? "" : condensed ? "Call: " : ""}${formText?.number}`}
        </Button>
        {!condensed && (
          <Button size="small" onClick={handleCopy} style={{ height: 44, background: "#fafafa" }}>
            {copied ? <Check style={{ fontSize: 20 }} /> : <FileCopy style={{ fontSize: 16 }} />}
          </Button>
        )}
      </ButtonGroup>
    </div>
  );
};
